import { Component, OnInit } from '@angular/core';
import { Event, Router, NavigationStart, NavigationEnd, RouterOutlet } from "@angular/router";
import { PlatformLocation, isPlatformBrowser } from "@angular/common";
import { PLATFORM_ID, Inject } from "@angular/core";
import { PageLoaderComponent } from "./layout/page-loader/page-loader.component";
import { InactivityService } from './core/service/inactivity.service';

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    imports: [PageLoaderComponent, RouterOutlet]
})
export class AppComponent implements OnInit {
  currentUrl: string;
  constructor(
    public _router: Router, 
    location: PlatformLocation, 
    @Inject(PLATFORM_ID) private platformId: Object,
    private inactivityService: InactivityService
  ) {
    this._router.events.subscribe((routerEvent: Event) => {
      if (routerEvent instanceof NavigationStart) {
        this.currentUrl = routerEvent.url.substring(
          routerEvent.url.lastIndexOf("/") + 1
        );
      }
      if (routerEvent instanceof NavigationEnd) {
      }
      if (isPlatformBrowser(this.platformId)) {
        window.scrollTo(0, 0);
      }
    });
  }

  ngOnInit() {
    this.inactivityService.start();
  }
}
